import dynamic from "next/dynamic";

export const ParallaxHexagon = dynamic(() => import("./component"));
